import { createApp } from 'vue';
import App from './App.vue';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import router from './router/index.js'; // Vue Routerをインポート
import axios from './api/axios'; // カスタマイズされたAxiosインスタンスをインポート
import store from './store'; // Vuex ストアをインポート
import clickOutside from './directives/clickOutside';

const app = createApp(App);

app.config.globalProperties.$axios = axios; // 全てのコンポーネントで $axios として使用できるようにする

app.use(store); // ストアをアプリケーションに組み込む
app.use(router);
app.directive('click-outside', clickOutside);
app.mount('#app');
